const Knex = require('./knex-builder/Knex');

module.exports = Knex;
